<template>
  <div>
    <b-modal
      id="modal-atendimentos"
      ref="modalAtendimentos"
      title="Atendimentos"
      v-model="localEnabled"
      centered
      hide-footer
      size="lg"
      scrollable
      @hidden="handleClose"
    >
      <template #modal-title>
        <strong>{{ profissional?.no_profissional }}</strong>
      </template>
      <div class="atendimentos">
        <div class="row">
          <div class="col-md-4 col-12">
            <label for="datepicker-full-width">Data início</label>
            <input class="form-control" v-model="data_inicio" type="date" />
          </div>
          <div class="col-md-4 col-12">
            <label for="datepicker-full-width">Data fim</label>
            <input class="form-control" v-model="data_fim" type="date" />
          </div>
          <div class="row col-md-4 col-12">
            <div class="actions-buttons">
              <button type="button" class="btn" @click="filtrarPorDatas()">
                Filtrar <i class="icofont-search"></i>
              </button>
              <button type="button" class="btn" @click="clear()">
                Limpar <i class="icofont-trash"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="info-table">
          <div class="info-table-item">
            <p class="fonte">
              <b>Fonte:</b> e-SUS PEC, {{ ultimaAtualizacao }}
            </p>
          </div>
          <div class="info-table-item">
            <b>{{ totalAtendimentos() }}</b> atendimentos realizados
          </div>
          <div
            v-if="
              $store.state.id_funcao == 1 ||
              $store.state.id_funcao == 2 ||
              $store.state.id_funcao == 7 ||
              $store.state.id_funcao == 4
            "
            class="info-table-item"
          >
            <button class="btn-pdf" v-on:click="generatePdf()">
              <i class="icofont-print"></i> PDF
            </button>
          </div>
        </div>
        <table class="table table-responsive table-striped" id="table">
          <thead class="thead-light">
            <tr>
              <th>Data</th>
              <th>Manhã</th>
              <th>Tarde</th>
              <th>Noite</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in atendimentosFiltrados" :key="index">
              <td>{{ formatDate(item.dt_atendimento) }}</td>
              <td>{{ item.manha !== null ? item.manha : '' }}</td>
              <td>{{ item.tarde !== null ? item.tarde : '' }}</td>
              <td>{{ item.noite !== null ? item.noite : '' }}</td>
              <td>{{ item.total_dia !== null ? item.total_dia : '' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
  </div>
</template>

<script>
import utils from '@/mixins/utils.js'
import * as Functions from './functions.js'

export default {
  props: {
    enabled: {
      type: Boolean,
      default: false,
    },
    atendimentos: {
      type: Array,
      default: () => [],
    },
    profissional: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [utils],
  data() {
    return {
      data_inicio: '',
      data_fim: '',
      atendimentosFiltrados: [],
    }
  },
  computed: {
    localEnabled: {
      get() {
        return this.enabled
      },
      set(value) {
        this.$emit('update:enabled', value)
      },
    },
    ultimaAtualizacao() {
      return this.$store.getters['getUltimaAtualizacao']
    },
  },
  watch: {
    atendimentos: {
      handler(newVal) {
        this.atendimentosFiltrados = [...newVal] // Inicialmente copiar os atendimentos passados pela prop para a lista local
      },
      immediate: true,
    },
  },
  methods: {
    formatarData(data) {
      let dia = String(data.getDate()).padStart(2, '0')
      let mes = String(data.getMonth() + 1).padStart(2, '0') // Os meses são indexados a partir de 0, por isso é adicionado +1
      let ano = data.getFullYear()

      return dia + '/' + mes + '/' + ano
    },

    handleClose() {
      this.$emit('update:enabled', false)
      this.clear()
    },

    generatePdf() {
      Functions.generatePdf(
        this.atendimentosFiltrados,
        this.profissional.no_profissional,
        this.totalAtendimentos(),
        this.data_inicio,
        this.data_fim
      )
    },

    totalAtendimentos() {
      return this.atendimentosFiltrados.reduce(function (acc, obj) {
        let total_dia = Number(obj.total_dia) || 0
        return acc + total_dia
      }, 0)
    },

    filtrarPorDatas() {
      try {
        // Obtenha as datas iniciais e finais selecionadas pelo usuário
        const dataInicial = new Date(this.data_inicio)
        const dataFinal = new Date(this.data_fim)

        const dataAtual = new Date()
        const data90diasAtras = new Date(
          dataAtual.getFullYear(),
          dataAtual.getMonth(),
          dataAtual.getDate() - 90
        )

        const data90diasAtrasFormatada = this.formatarData(data90diasAtras)
        if (dataInicial < data90diasAtras) {
          this.$toast.error(
            'Erro.',
            `A data inicial não pode ser inferior a ${data90diasAtrasFormatada}.`,
            {
              position: 'topRight',
            }
          )
          return false
        }

        // Filtrar a lista de atendimentos com base nas datas selecionadas
        this.atendimentosFiltrados = this.atendimentos.filter((cadastro) => {
          const dtAtendimento = new Date(cadastro.dt_atendimento)

          // Verificar se a data do atendimento está entre as datas selecionadas
          return dtAtendimento >= dataInicial && dtAtendimento <= dataFinal
        })
      } catch (error) {
        this.$toast.error('Data inválida!', 'Error:', {
          position: 'topRight',
        })
      }
    },

    clear() {
      this.data_inicio = ''
      this.data_fim = ''
      this.atendimentosFiltrados = [...this.atendimentos]
    },
  },
}
</script>

<style lang="scss">
#modal-atendimentos {
  .actions-buttons {
    display: flex;
    align-items: flex-end;
    gap: 10px;
  }
}
</style>
